import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-asset-preview-lib/internal/shared/components/AsyncComponentErrorHandler';
const AsyncCrmSendsByUser = Loadable({
  loader: () => import( /* webpackChunkName: "crm-sends-by-user" */'./CrmSendsByUser').then(mod => mod.default).catch(AsyncComponentErrorHandler('crm-sends-by-user')),
  LoadingComponent: () => null
});
export default AsyncCrmSendsByUser;